import { useIsPeerReviewEnabled } from "@components/QaReview/hooks/useIsPeerReviewEnabled";
import { useIsQaScanActive } from "@components/QaReview/hooks/useIsQaScanActive";

export const useCanComment = (): boolean => {
  const isPeerReviewEnabled = useIsPeerReviewEnabled();
  const isQaScanActive = useIsQaScanActive();

  return isPeerReviewEnabled && isQaScanActive;
};
